exports.components = {
  "component---src-templates-article-page-template-index-js": () => import("./../../../src/templates/ArticlePageTemplate/index.js" /* webpackChunkName: "component---src-templates-article-page-template-index-js" */),
  "component---src-templates-landing-page-template-index-js": () => import("./../../../src/templates/LandingPageTemplate/index.js" /* webpackChunkName: "component---src-templates-landing-page-template-index-js" */)
}

